var _ = require('underscore');
var TorsoView = require('backbone-torso/modules/View');
var authTemplate = require('./authTemplate.hbs');
var AuthFormView = require('./AuthFormView');
var AuthenticationFooterView = require('./AuthenticationFooterView');
var viewUtils = require('./../utils/viewUtils');

var AUTH_CONTEXTS = AuthFormView.AUTH_CONTEXTS;

/**
 * Perspective to display the portal authentication page
 *
 * @class AuthPerspective
 * @constructor
 * @param options {Object}
 *   @param [options.authContext=AUTH_CONTEXTS.PORTAL_PATIENT] {String} the auth context to render in.
 *   @param [options.navigateToPageFn=_.noop] {Function} a function that is run when authentication is successful.
 *   @param [options.moduleNamespace='authPerspective'] {String} identifier for this perspective in message keys.
 */
var AuthPerspective = TorsoView.extend({
  className: 'brec-authentication portal-authentication--portal',
  template: authTemplate,
  moduleNamespace: 'authPerspective',

  AUTH_CONTEXTS: AUTH_CONTEXTS,

  /**
   * @method initialize
   * @param options {Object}
   *   @param [options.authContext=AUTH_CONTEXTS.PORTAL_PATIENT] {String} the auth context to render in.
   *   @param [options.navigateToPageFn=_.noop] {Function} a function that is run when authentication is successful.
   *   @param [options.moduleNamespace='authPerspective'] {String} identifier for this perspective in message keys.
   * @override
   */
  initialize: function(options) {
    var defaultOptions = {
      authContext: AUTH_CONTEXTS.PORTAL_PATIENT,
      formView: AuthFormView
    };
    options = _.defaults({}, options, defaultOptions);

    this.set('isPatient', options.authContext.isPatient);

    if (!options.authContext.isPatient) {
      viewUtils.updateViewClassNameDuringInitialize(this, 'brec-authentication portal-authentication--admin');
    }

    this.moduleNamespace = options.moduleNamespace || this.moduleNamespace;

    this._authFormView = new options.formView({
      authContext: options.authContext,
      navigateToPageFn: options.navigateToPageFn
    });

    this._footerView = new AuthenticationFooterView({ isPatient: options.authContext.isPatient });
  },

  /**
   * @method attachTrackedViews
   * @override
   */
  attachTrackedViews: function() {
    this.attachView('main', this._authFormView);
    this.attachView('footer', this._footerView);
  }
});

AuthPerspective.AUTH_CONTEXTS = AUTH_CONTEXTS;

module.exports = AuthPerspective;
